// extracted by mini-css-extract-plugin
module.exports = {"container":"PendingDocuments_container__2xNbt","dataContainer":"PendingDocuments_dataContainer__3BcCb"};